import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ModalRecoverRegister",
  tabindex: "-1",
  "aria-labelledby": `ModalRecoverRegister`,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header gap-4" }
const _hoisted_5 = {
  class: "modal-title",
  id: "ModalRecoverRegisterLabel",
  style: {"color":"var(--cor_texto_1)","margin-right":"auto"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6641 9L17.5503 4.11377C18.1499 3.51416 18.1499 2.54199 17.5503 1.94189L16.4644 0.855957C15.8647 0.256348 14.8926 0.256348 14.2925 0.855957L9.40625 5.74219L4.52002 0.855957C3.92041 0.256348 2.94824 0.256348 2.34814 0.855957L1.26221 1.94189C0.662598 2.5415 0.662598 3.51367 1.26221 4.11377L6.14844 9L1.26221 13.8862C0.662598 14.4858 0.662598 15.458 1.26221 16.0581L2.34814 17.144C2.94775 17.7437 3.92041 17.7437 4.52002 17.144L9.40625 12.2578L14.2925 17.144C14.8921 17.7437 15.8647 17.7437 16.4644 17.144L17.5503 16.0581C18.1499 15.4585 18.1499 14.4863 17.5503 13.8862L12.6641 9Z",
      fill: "#B5B5C3"
    })
  ])
], -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { style: {"color":"var(--cor_texto_1)"} }
const _hoisted_9 = { class: "modal-footer gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn background_btn_1_opct m-0",
  "data-bs-dismiss": "modal"
}, "Cancelar", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"color":"var(--cor_icones_1)"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.header), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.message) + " Deseja recuperar ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1),
            _createTextVNode("? ")
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            type: "button",
            "data-bs-dismiss": "modal",
            style: {"color":"var(--cor_icones_1)"},
            "aria-label": "Close",
            class: "btn background_btn_1 m-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleButtonClick && _ctx.handleButtonClick(...args)))
          }, [
            _hoisted_11,
            _createTextVNode(" Recuperar ")
          ])
        ])
      ])
    ])
  ]))
}